import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

import {
  getDefaultFaqItems,
  getDefaultMechanicParams,
  getDefaultPrizes,
} from "../../../constants/mechanic-defaults";
import { type CreateGamificationFormData } from "../../../validations/gamification.validation";
import { BasicInfoCard } from "../BasicInfoCard";

export const StepBasics: React.FC = () => {
  const form = useFormContext<CreateGamificationFormData>();
  const campaignName = useWatch({
    control: form.control,
    name: "campaignName",
  });

  return (
    <BasicInfoCard
      register={form.register}
      control={form.control}
      errors={form.formState.errors}
      campaignNameLength={campaignName?.length || 0}
      onCampaignTypeChange={(type) => {

        form.setValue("mechanicConfig.prizes", getDefaultPrizes(type));
        form.setValue("faqItems", getDefaultFaqItems(type));

        form.setValue(
          "mechanicConfig.mechanicParams",
          getDefaultMechanicParams(type),
        );
      }}
    />
  );
};
